import { type ComponentPropsWithoutRef, type ReactNode, Fragment } from 'react';
import cx from 'clsx';
import type { Section, Item as ItemType } from 'app/react/api/models/section';
import { Item } from './item';
import styles from './items-table.module.css';

interface ItemsTableProps extends ComponentPropsWithoutRef<'table'> {
  sections?: Section[];
  items?: ItemType[];
  isImported?: boolean;
}

export function ItemsTable({
  sections,
  items,
  className,
  isImported = false,
  ...props
}: ItemsTableProps): ReactNode {
  // Skip mapping items and sections if invoice is imported
  if (isImported) {
    return null;
  }

  const hasSections = sections && sections.length > 0;
  const hasItems = items && items.length > 0;

  return (
    <table className={cx(styles.items, className)} data-testid="items-table" {...props}>
      <tbody data-testid="items-table-body">
        {hasSections
          ? sections.map(({ title, items: sectionItems }, index) => (
              // eslint-disable-next-line react/no-array-index-key -- static array
              <Fragment key={`${index}-${title}`}>
                {sectionItems.map(item => (
                  <Item
                    data-testid={`section-item-${item.productId}`}
                    item={item}
                    key={item.productId}
                  />
                ))}
              </Fragment>
            ))
          : null}
        {hasItems
          ? items.map(item => <Item data-testid={`item-${item.id}`} item={item} key={item.id} />)
          : null}
      </tbody>
    </table>
  );
}
